import React, { useContext, useMemo } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import { useNotifications } from '../../contexts/notificationContext';
import { EUIProgressIndicator } from '../EUI/EUIProgressIndicator';

const MainProgressIndicator = () => {

    // CONTEXTS
    const { messages } = useContext(ImmocomContext); // Ancienne version, � supprimer une fois migr�e
    const { loadingMessages } = useNotifications();

    // MEMOS
    const notifications = useMemo(() => {
        let merged = [];
        if (Array.isArray(messages)) merged = merged.concat(messages.filter(message => message.type === "loading"));
        if (Array.isArray(loadingMessages)) merged = merged.concat(loadingMessages);
        return merged;
    }, [loadingMessages, messages]);

    // RENDER
    if (notifications.length > 0)
        return <EUIProgressIndicator id="mainProgressIndicator" label={notifications[0].message} />;
    else return null;

};

export default MainProgressIndicator;